/* eslint-disable react/prop-types */
import React, { useEffect, useContext, useState } from 'react';
import 'moment/locale/fi';
import API from 'constants/api';
import LocaleContext from 'constants/localization';
import update from 'immutability-helper';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import Loading from 'components/common/Loading';
import { resToJsonHandleErrors, actionSuccess } from 'helpers/actionHelpers';

// SPEC-315 Admin view
const HelpMessagesView = () => {
  const LS = useContext(LocaleContext);
  const [helpMessages, setHelpMessages] = useState([]);
  const [current, setCurrent] = useState([]);
  const [loading, setLoading] = useState([]);

  useEffect(() => {
    setLoading(true);
    fetch(API.UI.HELP_MESSAGES)
      .then(resToJsonHandleErrors)
      .then(messages => {
        setHelpMessages(messages);
        if (messages.length > 0) {
          setCurrent(messages[0]);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const setCurrentValue = e => {
    setCurrent(update(current, { message: { $set: e.target. value }}));
  };

  const updateAndChange = (helpMessage) => {
    const index = helpMessages.findIndex(m => m.value === helpMessage.value);
    setHelpMessages(update(helpMessages, { [index]: { $set: helpMessage }}));
    setCurrent(helpMessage);
  };

  const updateMessage = () => {
    updateAndChange(current);
    const params = new URLSearchParams({
      predicate: current.value,
      message: current.message
    });

    fetch(`${API.UI.HELP_MESSAGES}?${params.toString()}`,
      { method: 'POST' })
      .then(resToJsonHandleErrors)
      .then(() => actionSuccess('helpTextSaved'));
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <h1>{LS.helpMessages}</h1>
      <Form.Group>
        <Select 
          options={helpMessages}
          value={current}
          onChange={updateAndChange}
        />
        <div className="value flex-left">
          <Form.Control
            style={{ margin: '1rem 0' }}
            as="textarea"
            value={current.message}
            onChange={setCurrentValue}
          />
          <button
            className="value-button" 
            onClick={updateMessage}>
            {LS.actions.save}
          </button>
        </div>
      </Form.Group>
    </div>
  ); 
};

export default HelpMessagesView;